import { render, staticRenderFns } from "./edit-refund.vue?vue&type=template&id=1ff8bd03&scoped=true&"
import script from "./edit-refund.vue?vue&type=script&lang=js&"
export * from "./edit-refund.vue?vue&type=script&lang=js&"
import style0 from "./edit-refund.vue?vue&type=style&index=0&id=1ff8bd03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8bd03",
  null
  
)

export default component.exports